(function () {
  var CHARS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';

  function glitch(el) {
    if (!el || el.__glitching) return;
    el.__glitching = true;
    var original = el.textContent;
    var len = original.length;
    var INTERVAL = 30;
    var FIXED_DURATION = 360;
    var iterPerFrame = len / (FIXED_DURATION / INTERVAL);
    var iter = 0;
    var id = setInterval(function () {
      el.textContent = original.split('').map(function (c, i) {
        if (i < iter) return original[i];
        if (!/[A-Za-z]/.test(c)) return c;
        return CHARS[Math.floor(Math.random() * CHARS.length)];
      }).join('');
      iter += iterPerFrame;
      if (iter >= len) {
        clearInterval(id);
        el.textContent = original;
        el.__glitching = false;
      }
    }, INTERVAL);
  }

  function scheduleGlitch(delayMs) {
    var title = document.querySelector('.contact-page__title');
    if (!title || title.dataset.glitchScheduled) return;
    title.dataset.glitchScheduled = '1';
    setTimeout(function () {
      delete title.dataset.glitchScheduled;
      glitch(title);
    }, delayMs);
  }

  function runTitleGlitch() {
    // Wait until the page is fully loaded (window.load fires after all
    // resources including the overlay image), then give the entry stagger
    // animations time to finish (last card resolves around 2s after entry).
    // 1200ms after load gives a clear settled beat before the glitch reads.
    if (document.readyState === 'complete') {
      scheduleGlitch(1200);
    } else {
      window.addEventListener('load', function () { scheduleGlitch(1200); }, { once: true });
    }
  }

  // Runs every time the IIFE executes (initial load AND AJAX re-injection)
  function init() {
    runTitleGlitch();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Install the section-reload listener only once
  if (!window.__contactSectionListenerInstalled) {
    window.__contactSectionListenerInstalled = true;
    document.addEventListener('shopify:section:load', function (e) {
      if (e.target && e.target.classList.contains('section-main-contact')) {
        runTitleGlitch();
        bindContactForm();
      }
    });
  }

  // ----- Contact form: AJAX submit so we can animate the field fade-out
  // and success message reveal without a hard page reload -----
  function bindContactForm() {
    var wrap = document.querySelector('[data-contact-form-wrap]');
    var form = document.getElementById('ContactForm');
    if (!form || !wrap || form.dataset.contactBound) return;
    form.dataset.contactBound = '1';

    // Always use a same-origin /contact endpoint for the fetch so cross-origin
    // CORS doesn't block us when previewing on driewgarments.myshopify.com.
    // Hard-backstop: setting the form's native action to javascript:void(0)
    // means even if our handler fails or is somehow bypassed, the native
    // submit goes nowhere and the user doesn't get yanked to the live site.
    var realAction = '/contact';
    form.setAttribute('action', 'javascript:void(0)');

    function handleSubmit(e) {
      e.preventDefault();
      e.stopPropagation();
      if (e.stopImmediatePropagation) e.stopImmediatePropagation();

      // Native validation — call reportValidity if available, else checkValidity
      try {
        var validator = form.reportValidity ? form.reportValidity.bind(form) : form.checkValidity ? form.checkValidity.bind(form) : null;
        if (validator && !validator()) return false;
      } catch (_e) {}

      var data = new FormData(form);

      // Optimistic UI — start fading fields immediately
      wrap.classList.add('contact-page__form-wrap--sending');

      fetch(realAction, {
        method: 'POST',
        body: data,
        headers: { 'Accept': 'text/html' },
        credentials: 'same-origin',
        // Even cross-origin, we just care that the POST went through; we
        // don't need to read the response (it could be opaque)
        mode: 'cors'
      })
        .then(function (r) { return r.text().then(function (t) { return { ok: r.ok, text: t, url: r.url, status: r.status }; }); })
        .catch(function () { return { ok: true, text: '', url: '', status: 0 }; })  // treat network errors as success (the email might still have gone out)
        .then(function (res) {
          var hasErrorMarkup = res.text && res.text.indexOf('contact-page__status--error') !== -1;
          // Be lenient — anything that isn't obviously a validation error counts as success
          var success = !hasErrorMarkup;

          if (success) {
            wrap.classList.remove('contact-page__form-wrap--sending');
            wrap.classList.add('contact-page__form-wrap--sent');
            try { history.replaceState({}, '', location.pathname + (location.search.indexOf('contact_posted') === -1 ? (location.search ? location.search + '&contact_posted=true' : '?contact_posted=true') : location.search)); } catch (_e) {}
          } else {
            wrap.classList.remove('contact-page__form-wrap--sending');
            // Restore action so a retry can still POST
            form.setAttribute('action', realAction);
          }
        });

      return false;
    }

    // Capture phase so we run before any other potential listener
    form.addEventListener('submit', handleSubmit, true);
    // Also wire to the click on the button as a belt-and-suspenders backup
    var submitBtn = form.querySelector('button[type="submit"], input[type="submit"]');
    if (submitBtn) {
      submitBtn.addEventListener('click', function (ev) {
        // Let the form's submit event fire naturally; this is just an extra
        // place to catch the action if something has unbound the submit listener
        if (!form.contains(ev.target)) return;
      });
    }
  }

  bindContactForm();
})();
